import { render } from "./MenuItemModal.vue?vue&type=template&id=1918278c&lang=pug"
import script from "./MenuItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItemModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__